import React from 'react';
import sal from 'sal.js';

import Layout from '~/layouts/header-footer';

import './work.scss';

import { BrandTile } from '~/components/tile';
import SEO from '~/components/seo';

import UniwhereLogo from '~/assets/images/icons/logos/uniwhere-logo.svg';
import WeAppHeroesLogo from '~/assets/images/icons/logos/weappheroes-logo.svg';
import Eighteen79Logo from '~/assets/images/icons/logos/eighteen79-logo.svg';
import XMEPayLogo from '~/assets/images/icons/logos/xme-pay-logo.svg';
import ZalandoLogo from '~/assets/images/icons/logos/zalando-logo.svg';

class WorkPage extends React.Component {
  componentDidMount() {
    sal({
      threshold: 0.1,
    });
  }

  render = () => pug`
    Layout
      SEO(title="Work", description="Some selected projects I'm proud of.")
      .work
        .page__intro
          h1(data-sal="text-animation") Work
          h5 Some selected projects I'm proud of.
        .page__grid.grid.grid--thirds
          .work-container(data-sal="slide-up", style={ transitionDelay: 0.1 * 0 + 's' })
            BrandTile(to="/work/zalando", color="#ff6900")
              ZalandoLogo
          .work-container(data-sal="slide-up", style={ transitionDelay: 0.1 * 1 + 's' })
            BrandTile(to="/work/uniwhere", color="#ff1940")
              UniwhereLogo
          .work-container(data-sal="slide-up", style={ transitionDelay: 0.1 * 2 + 's' })
            BrandTile(to="/work/eighteen79", color="#05f")
              Eighteen79Logo
          .work-container.work-container--xmepay(data-sal="slide-up", style={ transitionDelay: 0.1 * 3 + 's' })
            BrandTile.tile--xmepay(to="/work/crispybacon-intesa-sanpaolo-xmepay", large=true, color="#258900")
              XMEPayLogo
          .work-container(data-sal="slide-up", style={ transitionDelay: 0.1 * 4 + 's' })
            BrandTile.tile--weappheroes(to="/work/weappheroes", color=" #14636f")
              WeAppHeroesLogo
          .work-container(data-sal="slide-up", style={ transitionDelay: 0.1 * 5 + 's' })
            BrandTile.tile--portfolio(to="/work/portfolio")
              .tile--portfolio__palm
  `;
}

export default WorkPage;
